import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const deleteFee = ({ id }) => {
  return axios.delete(`/fee/${id}`);
};

deleteFee.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useDeleteFee = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (deletedFee) => {
      await queryClient.cancelQueries('currency_fees');

      const previousFees = queryClient.getQueryData('currency_fees');

      queryClient.setQueryData(
        'currency_fees',
        previousFees?.filter((fee) => fee.id !== deletedFee.id)
      );

      return { previousFees };
    },
    onError: (_, __, context) => {
      if (context?.previousFees) {
        queryClient.setQueryData('currency_fees', context.previousFees);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries('currency_fees');
      addNotification({
        type: 'success',
        title: 'Fee Deleted',
      });
    },
    ...config,
    mutationFn: deleteFee,
  });
};
